import React, { useState } from "react";
import { Tabs } from "@caelor/ui";
import { useTranslation } from "react-i18next";
import { TabsSettings } from "./defaults";
import LayoutSettings from "./LayoutSettings";
import ContentSettings from "./ContentSettings";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

function OrgChartSettings() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("content");

  return (
    <DndProvider backend={HTML5Backend}>
      <Tabs
        tabs={TabsSettings}
        i18n={t}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      {selectedTab === "layout" && <LayoutSettings />}
      {selectedTab === "content" && <ContentSettings />}
    </DndProvider>
  );
}

export default OrgChartSettings;
